import React from 'react';

type Props = {
  word: string;
  // Array of characters
  guessedLetters: Array<string>;
  onPersonHung?: () => void;
};

const enum PersonPart {
  Rope,
  Head,
  Body,
  LeftArm,
  RightArm,
  LeftLeg,
  RightLeg,
  LeftEye,
  RightEye,
  Mouth,
};

const PERSON_PARTS: Array<PersonPart> = [
  PersonPart.Rope,
  PersonPart.Head,
  PersonPart.Body,
  PersonPart.LeftArm,
  PersonPart.RightArm,
  PersonPart.LeftLeg,
  PersonPart.RightLeg,
  PersonPart.LeftEye,
  PersonPart.RightEye,
  PersonPart.Mouth,
];
const MAX_INCORRECT_GUESSES = PERSON_PARTS.length;

function HangingPerson({word, guessedLetters, onPersonHung}: Props): React.JSX.Element {
  const incorrectlyGuessedLetters = guessedLetters.filter((guessedLetter) => !word.includes(guessedLetter));
  const incorrectGuesses = incorrectlyGuessedLetters.length;

  React.useEffect(() => {
    if (incorrectGuesses >= MAX_INCORRECT_GUESSES && onPersonHung != null) {
      onPersonHung();
    }
  }, [incorrectGuesses, onPersonHung]);

  const shownParts = PERSON_PARTS.slice(0, incorrectGuesses);

  return (
    <div className="hanging-person">
      <svg width="800" height="600" xmlns="http://www.w3.org/2000/svg">
        <g>
          <line style={{display: shownParts.includes(PersonPart.Rope) ? 'block' : 'none'}} fill="none" x1="423.85774" y1="154" x2="582" y2="153" id="svg_1" stroke-linejoin="undefined" stroke-linecap="undefined" stroke="#000" className="rope"/>
          <line style={{display: shownParts.includes(PersonPart.Rope) ? 'block' : 'none'}} fill="none" x1="580.93023" y1="153.02326" x2="581.39535" y2="284.76799" id="svg_3" stroke-linejoin="undefined" stroke-linecap="undefined" stroke="#000" className="rope"/>
          <line style={{display: shownParts.includes(PersonPart.Rope) ? 'block' : 'none'}} fill="none" x1="424.66667" y1="153.66667" x2="424.33333" y2="183.16665" id="svg_4" stroke-linejoin="undefined" stroke-linecap="undefined" stroke="#000" className="rope"/>
          <ellipse style={{display: shownParts.includes(PersonPart.Head) ? 'block' : 'none'}} className="head" fill="none" stroke="#000" cx="425.24093" cy="205.66111" id="svg_5" rx="20.24978" ry="21.49976"/>
          <line style={{display: shownParts.includes(PersonPart.Body) ? 'block' : 'none'}} className="body" id="svg_6" y2="264.99942" x2="425.24918" y1="227.74946" x1="424.99918" stroke="#000" fill="none"/>
          <line style={{display: shownParts.includes(PersonPart.LeftArm) ? 'block' : 'none'}} fill="none" stroke="#000" x1="425.65902" y1="238.99503" x2="442.9922" y2="248.32828" id="svg_7" className="left-arm"/>
          <line style={{display: shownParts.includes(PersonPart.RightArm) ? 'block' : 'none'}} fill="none" stroke="#000" x1="424.3257" y1="238.99503" x2="410.99249" y2="246.99496" id="svg_9" className="right-arm"/>
          <line style={{display: shownParts.includes(PersonPart.LeftLeg) ? 'block' : 'none'}} className="left-leg" id="svg_2" y2="278.41279" x2="442.32767" y1="264.66288" x1="425.32779" stroke="#000" fill="none"/>
          <line style={{display: shownParts.includes(PersonPart.RightLeg) ? 'block' : 'none'}} fill="none" x1="424.83325" y1="264.66663" x2="410.33325" y2="277.99996" id="svg_8" stroke="#000" className="right-leg"/>
          <circle style={{display: shownParts.includes(PersonPart.LeftEye) ? 'block' : 'none'}} cx="418" cy="199" r="2" stroke="#000" fill="#000" className="left-eye"/>
          <circle style={{display: shownParts.includes(PersonPart.RightEye) ? 'block' : 'none'}} cx="432" cy="199" r="2" stroke="#000" fill="#000" className="right-eye"/>
          <line style={{display: shownParts.includes(PersonPart.Mouth) ? 'block' : 'none'}} x1="418" y1="210" x2="432" y2="210" stroke="#000" className="mouth"/>
        </g>
      </svg>
    </div>
  );
}

export default HangingPerson;
